import React, { useMemo, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Input, Row, Col, Space } from 'antd';
import Button from '@mui/material/Button';
import ButtonGroup from "@mui/material/ButtonGroup";
import { SaveRounded, FileCopyRounded, UnfoldMoreRounded, UnfoldLessRounded,
    LightbulbRounded, TuneRounded
} from "@mui/icons-material";
import useClipboard from '../../../../hooks/useClipboard'
import { useSelector } from "react-redux";
import { setSmaMode } from "../../../../store/slices/sma.slice";
import _ from 'lodash';

import { OutlinedInput } from '@mui/material';

const SmaMenu = ({ currentSmaConfig, updateConfig, handleSave, showEtfBanner, toggleEtfBanner, extra }) => {
    const dispatch = useDispatch();
    const isPublic = useSelector(state => state.public.isPublicAccess);
    const smaMode = useSelector(state => state.sma.mode);
    const [smaName, setSmaName] = useState(currentSmaConfig?.name || '');
    const copyToClipboard = useClipboard();

    const debouncedUpdateConfig = useMemo(() => _.debounce((newName) => {
        updateConfig('name', newName);
    }, 500), [updateConfig]);

    const handleNameChange = (e) => {
        const newName = e.target.value;
        setSmaName(newName);
        debouncedUpdateConfig(newName);
    };
    const toggleMode = () => {
        dispatch(setSmaMode(smaMode === 'simple' ? 'advanced' : 'simple'));
    }
    const tickerString = Object.keys(currentSmaConfig.etfs).map(x => "${x}").join(', ');


    return (

        <Row justify={'space-between'} className={'px-6 py-2'} gutter={12} wrap={false}>
            <Col>
                <Input
                    rootClassName={'primary bold'}
                    placeholder="Enter SMA Title.."
                    value={smaName}
                    onChange={handleNameChange}
                    sx={{ width: '100%', marginBottom: '20px' }}
                    size="small"
                    helperText={'SMA Title'}
                />
            </Col>
            <Col>
                <Space>
                    {!isPublic && <Button variant="contained" startIcon={<SaveRounded />} onClick={handleSave}>Save</Button>}

                    <ButtonGroup color="primary">
                        <Button variant="text" startIcon={<FileCopyRounded />} onClick={() => copyToClipboard(tickerString)}>Copy Tickers</Button>
                        {extra}
                    </ButtonGroup>
                </Space>
            </Col>
        </Row>
    );
};

export default SmaMenu;
